<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div class="spotlight-result-icon spotlight-result-icon--weather">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9z"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">{{ item.title }}</div>
            <div class="spotlight-result-subtitle">{{ item.subtitle }}</div>
        </div>
        <div v-if="hasTemp" class="spotlight-result-meta">
            <span class="spotlight-result-badge">{{ Math.round(item.meta.temperature) }}°C</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WeatherResult',
    props: { item: Object, focused: Boolean },
    emits: ['select'],
    computed: {
        hasTemp() {
            return this.item.meta?.temperature != null
        }
    }
}
</script>
